import { z } from 'zod';
import { FirstPostMessageSchema } from './firstPostIdeas';

export const StudioMessageSchema = z.object({
  journeyId: z.enum(['content-studio', 'welcome-to-poppy']),
  boardId: z.string().min(1).max(200),
  stepId: z.string().min(1).max(80),
  label: z.string().trim().min(1).max(300).optional(),
});

/** Keep implementation instructions out of the conversation without changing the saved request. */
export function coachMessageLabel(metadata: unknown): string | null {
  const result = z
    .union([FirstPostMessageSchema, StudioMessageSchema])
    .safeParse((metadata as { coach?: unknown } | null)?.coach);
  return result.success ? (result.data.label ?? null) : null;
}
